
import { Link } from 'react-router-dom';
import OptimizedImage from '../../../components/base/OptimizedImage';

const FeaturedCasesSection = () => {
  const featuredCases = [
    {
      id: 1,
      title: '新北板橋 3 房家庭搬遷',
      location: '新北市板橋區',
      category: '家庭搬遷',
      description: '陳先生一家四口從板橋舊公寓搬到新大樓，包含鋼琴和古董家具的專業搬運',
      image: 'https://public.readdy.ai/ai/img_res/8fadc4f2a0a8ece584e4dbe300d90e96.jpg',
      stats: {
        duration: '6 小時',
        workers: 4,
        rating: 5
      },
      highlight: '鋼琴搬運零損傷',
      link: '/case-detail-1'
    },
    {
      id: 2,
      title: '台北內湖科技公司搬遷',
      location: '台北市內湖區',
      category: '辦公室搬遷',
      description: '50坪科技公司搬遷，包含伺服器機櫃、電腦設備等精密儀器的專業搬運',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20technology%20company%20office%20relocation%2C%20professional%20movers%20handling%20computer%20servers%20and%20IT%20equipment%20with%20extreme%20care%20in%20Taipei%20Neihu%20district%2C%20organized%20cable%20management%20and%20technical%20equipment%20moving%2C%20modern%20tech%20office%20interior&width=600&height=400&seq=featured-case-2&orientation=landscape',
      stats: {
        duration: '8 小時',
        workers: 5,
        rating: 5
      },
      highlight: '設備零故障',
      link: '/case-detail-2'
    },
    {
      id: 3,
      title: '新竹東區鋼琴搬運',
      location: '新竹市東區',
      category: '精緻搬運',
      description: '直立式鋼琴從1樓搬到3樓，無電梯環境下的專業搬運服務',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20professional%20piano%20moving%20service%2C%20skilled%20movers%20carefully%20handling%20upright%20piano%20with%20specialized%20equipment%20and%20safety%20straps%2C%20stairway%20heavy%20lifting%20in%20Taiwanese%20residential%20building%2C%20protective%20materials%20and%20professional%20moving%20techniques&width=600&height=400&seq=featured-case-3&orientation=landscape',
      stats: {
        duration: '3 小時',
        workers: 3,
        rating: 5
      },
      highlight: '無電梯專業搬運',
      link: '/case-detail-3'
    }
  ];

  const processPhotos = [
    {
      id: 1,
      title: '專業防護包裝',
      description: '使用專業防護材料，確保家具零損傷',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Taiwan%20moving%20service%20workers%20carefully%20wrapping%20large%20sofa%20with%20thick%20protective%20blankets%20and%20stretch%20film%2C%20close-up%20of%20furniture%20protection%20process%2C%20clean%20organized%20workspace%2C%20professional%20moving%20equipment%20visible%2C%20high%20quality%20protective%20materials%2C%20bright%20natural%20lighting%20in%20Taiwanese%20apartment&width=400&height=300&seq=process-photo-1&orientation=landscape'
    },
    {
      id: 2,
      title: '大型家具搬運',
      description: '專業團隊協力搬運，安全有保障',
      image: 'https://readdy.ai/api/search-image?query=Two%20professional%20Taiwan%20movers%20in%20uniform%20carefully%20carrying%20large%20wooden%20wardrobe%20down%20apartment%20stairway%20using%20safety%20straps%20and%20proper%20lifting%20technique%2C%20teamwork%20coordination%2C%20residential%20building%20interior%2C%20professional%20moving%20service%20in%20action%2C%20careful%20handling&width=400&height=300&seq=process-photo-2&orientation=landscape'
    },
    {
      id: 3,
      title: '家電專業搬運',
      description: '冰箱洗衣機等大型家電安全運送',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20professional%20movers%20using%20specialized%20dolly%20cart%20to%20transport%20large%20refrigerator%20with%20protective%20padding%2C%20appliance%20moving%20service%2C%20careful%20handling%20of%20heavy%20household%20electronics%2C%20moving%20truck%20loading%20area%2C%20professional%20equipment%20and%20safety%20measures&width=400&height=300&seq=process-photo-3&orientation=landscape'
    },
    {
      id: 4,
      title: '物品分類打包',
      description: '細心分類標記，搬後整理更輕鬆',
      image: 'https://readdy.ai/api/search-image?query=Organized%20moving%20boxes%20with%20clear%20labels%20in%20Taiwanese%20apartment%2C%20professional%20packing%20service%20with%20categorized%20items%2C%20bubble%20wrap%20and%20packing%20materials%20visible%2C%20neat%20and%20systematic%20packing%20process%2C%20kitchen%20items%20and%20books%20being%20packed%20carefully&width=400&height=300&seq=process-photo-4&orientation=landscape'
    },
    {
      id: 5,
      title: '貨車裝載作業',
      description: '專業堆疊技術，空間利用最大化',
      image: 'https://readdy.ai/api/search-image?query=Inside%20view%20of%20Taiwan%20moving%20truck%20being%20loaded%20with%20furniture%20and%20boxes%2C%20professional%20stacking%20and%20organization%2C%20moving%20blankets%20protecting%20items%2C%20efficient%20space%20utilization%2C%20professional%20movers%20arranging%20items%20securely%20for%20transport&width=400&height=300&seq=process-photo-5&orientation=landscape'
    },
    {
      id: 6,
      title: '易碎品特殊處理',
      description: '玻璃製品、藝術品專業包裝保護',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20moving%20service%20worker%20carefully%20wrapping%20fragile%20glass%20items%20and%20picture%20frames%20with%20bubble%20wrap%20and%20foam%20padding%2C%20delicate%20item%20protection%2C%20professional%20packing%20materials%20for%20breakables%2C%20close-up%20of%20careful%20handling%20process&width=400&height=300&seq=process-photo-6&orientation=landscape'
    },
    {
      id: 7,
      title: '床墊專業包裝',
      description: '床墊套袋保護，乾淨衛生送達',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20in%20Taiwan%20placing%20mattress%20into%20protective%20plastic%20cover%20bag%2C%20bed%20moving%20service%2C%20clean%20and%20hygienic%20mattress%20transport%2C%20bedroom%20furniture%20relocation%2C%20professional%20moving%20supplies&width=400&height=300&seq=process-photo-7&orientation=landscape'
    },
    {
      id: 8,
      title: '樓梯搬運作業',
      description: '無電梯環境專業搬運，安全第一',
      image: 'https://readdy.ai/api/search-image?query=Taiwan%20professional%20movers%20carrying%20heavy%20furniture%20up%20narrow%20apartment%20stairway%20without%20elevator%2C%20teamwork%20and%20coordination%2C%20safety%20straps%20and%20proper%20technique%2C%20challenging%20residential%20moving%20situation%2C%20experienced%20moving%20team&width=400&height=300&seq=process-photo-8&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區 */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-star-fill"></i>
            <span>精選成功案例</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>最受歡迎的搬家案例</strong>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            每一個案例都是我們專業服務的見證，看看客戶如何評價我們的<strong>新北搬家</strong>、<strong>台北搬家</strong>服務
          </p>
        </div>

        {/* 案例卡片 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {featuredCases.map((caseItem, index) => (
            <Link
              key={caseItem.id}
              to={caseItem.link}
              className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2"
            >
              {/* 圖片區 */}
              <div className="relative h-56 overflow-hidden">
                <OptimizedImage
                  src={caseItem.image}
                  alt={caseItem.title}
                  className="w-full h-full"
                  priority={index === 0}
                />
                
                {/* 類別標籤 */}
                <div className="absolute top-4 left-4 bg-teal-600 text-white px-4 py-2 rounded-full shadow-lg z-10">
                  <span className="text-sm font-semibold">{caseItem.category}</span>
                </div>

                {/* 亮點標籤 */}
                <div className="absolute top-4 right-4 bg-yellow-400 text-yellow-900 px-4 py-2 rounded-full shadow-lg z-10">
                  <div className="flex items-center gap-1">
                    <i className="ri-trophy-line"></i>
                    <span className="text-sm font-semibold">{caseItem.highlight}</span>
                  </div>
                </div>

                {/* 地點標籤 */}
                <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg z-10">
                  <div className="flex items-center gap-2 text-teal-600">
                    <i className="ri-map-pin-line"></i>
                    <span className="text-sm font-semibold">{caseItem.location}</span>
                  </div>
                </div>

                {/* 懸停遮罩 */}
                <div className="absolute inset-0 bg-gradient-to-t from-teal-600/90 via-teal-600/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-8 z-20">
                  <div className="text-center text-white">
                    <i className="ri-eye-line text-4xl mb-2"></i>
                    <div className="text-lg font-bold">查看完整案例</div>
                  </div>
                </div>
              </div>

              {/* 內容區 */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {caseItem.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-2">
                  {caseItem.description}
                </p>

                {/* 統計數據 */}
                <div className="grid grid-cols-3 gap-3 mb-4">
                  <div className="bg-teal-50 rounded-xl p-3 text-center">
                    <i className="ri-time-line text-teal-600 text-lg"></i>
                    <div className="text-xs text-gray-600 mt-1">工時</div>
                    <div className="text-sm font-semibold text-gray-900">{caseItem.stats.duration}</div>
                  </div>
                  <div className="bg-emerald-50 rounded-xl p-3 text-center">
                    <i className="ri-team-line text-emerald-600 text-lg"></i>
                    <div className="text-xs text-gray-600 mt-1">人力</div>
                    <div className="text-sm font-semibold text-gray-900">{caseItem.stats.workers} 人</div>
                  </div>
                  <div className="bg-yellow-50 rounded-xl p-3 text-center">
                    <i className="ri-star-fill text-yellow-500 text-lg"></i>
                    <div className="text-xs text-gray-600 mt-1">評分</div>
                    <div className="text-sm font-semibold text-gray-900">{caseItem.stats.rating}.0</div>
                  </div>
                </div>

                {/* 查看按鈕 */}
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-1">
                    {[...Array(caseItem.stats.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400"></i>
                    ))}
                  </div>
                  <span className="text-teal-600 font-semibold text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                    查看詳情
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* 搬家過程實拍區塊 */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-camera-line"></i>
              <span>搬家過程實拍</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              專業搬家服務<strong>真實紀錄</strong>
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              從打包、防護、搬運到裝車，每一個環節都展現我們的專業與用心
            </p>
          </div>

          {/* 照片網格 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {processPhotos.map((photo) => (
              <div
                key={photo.id}
                className="group relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[4/3] w-full">
                  <OptimizedImage
                    src={photo.image}
                    alt={photo.title}
                    className="w-full h-full"
                  />
                </div>
                
                {/* 懸停資訊 */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                  <h4 className="text-white font-bold text-lg mb-1">{photo.title}</h4>
                  <p className="text-white/90 text-sm">{photo.description}</p>
                </div>

                {/* 底部標籤 */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3 group-hover:opacity-0 transition-opacity duration-300">
                  <div className="flex items-center gap-2 text-white text-sm font-medium">
                    <i className="ri-image-line"></i>
                    <span>{photo.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 服務特色標籤 */}
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <div className="flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-medium">
              <i className="ri-shield-check-line"></i>
              <span>全程防護包裝</span>
            </div>
            <div className="flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium">
              <i className="ri-team-line"></i>
              <span>專業搬運團隊</span>
            </div>
            <div className="flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-medium">
              <i className="ri-truck-line"></i>
              <span>安全運送保障</span>
            </div>
            <div className="flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium">
              <i className="ri-checkbox-circle-line"></i>
              <span>細心分類整理</span>
            </div>
          </div>
        </div>

        {/* 統計數據橫幅 */}
        <div className="bg-gradient-to-r from-teal-600 to-emerald-600 rounded-3xl p-8 shadow-xl mb-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">5000+</div>
              <div className="text-teal-100">成功案例</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">98%</div>
              <div className="text-teal-100">滿意度</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">4.9</div>
              <div className="text-teal-100">平均評分</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">0</div>
              <div className="text-teal-100">客訴紀錄</div>
            </div>
          </div>
        </div>

        {/* 查看更多按鈕 */}
        <div className="text-center">
          <Link
            to="/cases"
            className="inline-flex items-center gap-3 bg-teal-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-gallery-line text-xl"></i>
            <span>查看所有成功案例</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCasesSection;
